import { makeObservable, observable, action } from "mobx";
import axios from "axios";

axios.defaults.headers.common = {
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
  Expires: "0",
};

class AppSore {
  @observable index = null;
  @observable indexdata = null;
  @observable footerColumns = null;
  @observable searchBlock = null;
  @observable resourceConfig = null;
  @observable header = null;
  @observable openLogin = null;
  @observable sendURL = null;
  @observable filterPid = null;
  @observable dbResourceCount = 0;
  @observable journalResourceCount = 0;
  @observable journalResourceFilterCount = 0;
  @observable pJournalResourceCount = 0;
  @observable pJournalResourceFilterCount = 0;
  @observable ebookResourceCount = 0;
  @observable ebookResourceFilterCount = 0;
  @observable bookmarkCount = 0;
  @observable globalConfig = {};
  @observable loginRedirect = null;
  @observable checkedGuest = 0;
  @observable domain = "";
  @observable custDBResourceCount = 0;
  @observable custJournalResourceCount = 0;
  @observable custPJournalResourceCount = 0;
  @observable custEbookResourceCount = 0;
  @observable loginPage = "";
  @observable agreeTeacherArea = 0;
  @observable agreeStudentArea = 0;
  @observable ebookNoticeCount = 0;

  constructor() {
    makeObservable(this);
    this.getIndex();
    this.getIndexData();
    this.getFooter();
    this.getHeader();
    this.getSearchBlock();
    this.getResourceConfig();
  }

  @action.bound
  getIndex() {
    axios
      .get("/file/data/index.json")
      .then((res) => {
        this.setIndex(res.data);
      })
      .catch((error) => {
        //console.log("err=>" + error);
      });
  }

  @action.bound
  getIndexData() {
    axios
      .get("/file/data/indexdata.json")
      .then((res) => {
        this.setIndexData(res.data);
      })
      .catch((error) => {
        //console.log("err=>" + error);
      });
  }

  @action.bound
  getFooter() {
    axios
      .get("/file/data/footer.json")
      .then((res) => {
        let { footerColumns } = res.data;
        this.setFooterColumns(footerColumns);
      })
      .catch((error) => {
        //console.log("err=>" + error);
      });
  }

  @action.bound
  getHeader() {
    axios
      .get("/file/data/header.json")
      .then((res) => {
        this.setHeader(res.data);
      })
      .catch((error) => {
        //console.log("err=>" + error);
      });
  }

  @action.bound
  getSearchBlock() {
    axios
      .get("/file/data/searchBlock.json")
      .then((res) => {
        this.setSearchBlock(res.data);
      })
      .catch((error) => {
        //console.log("err=>" + error);
      });
  }

  @action.bound
  getResourceConfig() {
    axios
      .get("/file/data/resource.json")
      .then((res) => {
        this.setResourceConfig(res.data);
      })
      .catch((error) => {
        //console.log("err=>" + error);
      });
  }

  @action.bound
  setIndex = (index) => {
    if (
      index !== null &&
      index !== undefined &&
      index.domainList !== null &&
      index.domainList !== undefined
    ) {
      this.index = index;
    } else {
      this.index = {
        domainList: [],
      };
    }
  };

  @action.bound
  setIndexData = (indexdata) => {
    this.indexdata = indexdata;
  };

  @action.bound
  setFooterColumns = (footerColumns) => {
    this.footerColumns = footerColumns;
  };

  @action.bound
  setHeader = (header) => {
    this.header = header;
  };

  @action.bound
  setSearchBlock = (searchBlock) => {
    this.searchBlock = searchBlock;
  };

  @action.bound
  setResourceConfig = (resourceConfig) => {
    this.resourceConfig = resourceConfig;
  };

  @action.bound
  setOpenLogin = (openLogin) => {
    this.openLogin = openLogin;
  };

  @action.bound
  setSendURL = (sendURL) => {
    this.sendURL = sendURL;
  };

  @action.bound
  setFilterPid = (filterPid) => {
    this.filterPid = filterPid;
  };

  @action.bound
  setDBResourceCount = (dbResourceCount) => {
    this.dbResourceCount = dbResourceCount;
  };

  @action.bound
  setJournalResourceCount = (journalResourceCount) => {
    this.journalResourceCount = journalResourceCount;
  };

  @action.bound
  setJournalResourceFilterCount = (journalResourceFilterCount) => {
    this.journalResourceFilterCount = journalResourceFilterCount;
  };

  @action.bound
  setPJournalResourceCount = (pJournalResourceCount) => {
    this.pJournalResourceCount = pJournalResourceCount;
  };

  @action.bound
  setPJournalResourceFilterCount = (pJournalResourceFilterCount) => {
    this.pJournalResourceFilterCount = pJournalResourceFilterCount;
  };

  @action.bound
  setEbookResourceCount = (ebookResourceCount) => {
    this.ebookResourceCount = ebookResourceCount;
  };

  @action.bound
  setEbookResourceFilterCount = (ebookResourceFilterCount) => {
    this.ebookResourceFilterCount = ebookResourceFilterCount;
  };

  @action.bound
  setBookmarkCount = (bookmarkCount) => {
    this.bookmarkCount = bookmarkCount;
  };

  @action.bound
  setGlobalConfig = (config) => {
    this.globalConfig = config;
  };

  @action.bound
  setLoginRedirect = (loginRedirect) => {
    this.loginRedirect = loginRedirect;
  };

  @action.bound
  setCheckedGuest = (checkedGuest) => {
    this.checkedGuest = checkedGuest;
  };

  @action.bound
  setDomain = (domain) => {
    this.domain = domain;
  };

  @action.bound
  setCustDBResourceCount = (custDBResourceCount) => {
    this.custDBResourceCount = custDBResourceCount;
  };

  @action.bound
  setCustJournalResourceCount = (custJournalResourceCount) => {
    this.custJournalResourceCount = custJournalResourceCount;
  };

  @action.bound
  setCustPJournalResourceCount = (custPJournalResourceCount) => {
    this.custPJournalResourceCount = custPJournalResourceCount;
  };

  @action.bound
  setCustEbookResourceCount = (custEbookResourceCount) => {
    this.custEbookResourceCount = custEbookResourceCount;
  };

  @action.bound
  setLoginPage = (loginPage) => {
    this.loginPage = loginPage;
  };

  @action.bound
  setAgreeTeacherArea = (agreeTeacherArea) => {
    this.agreeTeacherArea = agreeTeacherArea;
  };

  @action.bound
  setAgreeStudentArea = (agreeStudentArea) => {
    this.agreeStudentArea = agreeStudentArea;
  };

  @action.bound
  setEbookNoticeCount = (ebookNoticeCount) => {
    this.ebookNoticeCount = ebookNoticeCount;
  };
}

export default AppSore;
